// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";

interface OwnProps {
    id: string;
}

export interface FooterInfoLinksContainerStyles {
    container?: InjectableCss;
    innerContainer?: InjectableCss;
    leftSection?: InjectableCss;
    linkListFirstItems?: InjectableCss;
    linkListItems?: InjectableCss;
    rightSection?: InjectableCss;
}

export const footerInfoLinksContainerStyles: FooterInfoLinksContainerStyles = {};

const styles = footerInfoLinksContainerStyles;
const FooterInfoLinksContainer: FC<OwnProps> = ({ id }) => {
    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.innerContainer}>
                <StyledWrapper {...styles.leftSection}>
                    <StyledWrapper {...styles.linkListFirstItems}>
                        <Zone zoneName="LinkList1" contentId={id} />
                    </StyledWrapper>
                    <StyledWrapper {...styles.linkListItems}>
                        <Zone zoneName="LinkList2" contentId={id} />
                    </StyledWrapper>
                    <StyledWrapper {...styles.linkListItems}>
                        <Zone zoneName="LinkList3" contentId={id} />
                    </StyledWrapper>
                </StyledWrapper>
                <StyledWrapper {...styles.rightSection}>
                    <Zone zoneName="Subscribe" contentId={id} />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default FooterInfoLinksContainer;
